import { forwardRef } from 'react';
import type { CSSProperties, HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import { spaceVar } from '../utils/space.js';
import type { SpaceToken } from '../utils/space.js';
import styles from './Stack.module.css';

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  /** A key on the --space-* scale. Defaults to 4 (12px). */
  gap?: SpaceToken;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
}

export const Stack = forwardRef<HTMLDivElement, StackProps>(function Stack(
  { gap = 4, align, justify, className, style, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cx(styles.stack, className)}
      style={{ gap: spaceVar(gap), alignItems: align, justifyContent: justify, ...style }}
      {...rest}
    />
  );
});
